import PropTypes from 'prop-types';
import React from 'react';
// import { Link, browserHistory } from 'react-router';
import cx from 'classnames';
import { Image, Button as SearchButton, Row, Col, Card } from 'react-bootstrap';
import _ from "lodash";
import buildUrl from 'build-url-ts';
import styles from './userGroupListView.module.scss';
import dateformat from 'dateformat';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import InfiniteScroll from 'react-infinite-scroller';
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import EmptyMessageIcon from "src/legacy/images/contactListEmptyMessage.svg";
import { localizedStrings } from 'src/localization/index.jsx';
import Text from 'src/components/text';
class UserGroupListView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
    }

    this._loadMoreUserGroups = this._loadMoreUserGroups.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedUser = this.localizedUserManagement.user_view;
  }

  componentDidMount() {
  }

  _loadMoreUserGroups() {
    var totalPages = this.props.totalPages;
    var current = this.props.currentPage;

    if(this.props.loading){
      return false;
    }

    this.props.fetchUserGroupsForUser(current + 1, this.props.user.id);
  }

  _renderFirstUserIcon(user) {
    return [
      <Image
        className={styles.userGroupIcon}
        src={user.icons[0].thumbnail}
        circle
      />,
      <div className={styles.defaultImage2}>
      <div className={cx(styles.userGroupCount1, styles.layer3)}></div>
      </div>,
      <div className={styles.defaultImage3}>
      <div className={cx(styles.userGroupCount1, styles.layer3)}></div>
      </div>,
    ];
  }

  _renderSecondUserIcon(user) {
    return [
      <Image
        className={styles.userGroupIcon}
        src={user.icons[0].thumbnail}
        circle
      />,
      <Image
        className={cx(styles.userGroupIcon, styles.layer1)}
        src={user.icons[1].thumbnail}
        circle
      />, 
        <div className={styles.userGroupContainer}>
        <div className={cx(styles.userGroupCount1, styles.layer3)}>
        {user.usersCount > 2 ? `+${user.usersCount - 2}` : ""}
        </div>
        </div> 
        , 
    ];
  }

  _renderDefaultIcon() {
    return [
      <div className={styles.userGroupCount}></div>,
      <div className={cx(styles.userGroupCount, styles.layer1)}></div>,
      <div className={cx(styles.userGroupCount, styles.layer2)}></div>,
    ];
  }

  _handleUserGroupClick(userGroup) {
    this.props.fetchUserGroup(userGroup.id);

    var queryParams = {};
    var query = "";
    if (query) {
      queryParams["query"] = query;
    }

    var path = buildUrl(null, {
      path: `/settings/user-management/group/${userGroup.id}`,
      queryParams: queryParams,
    });
    
    this.props.navigate(path);
  }

  render() {
    return (
        <div className={styles.listView}>
          <div className={styles.title}>{this.localizedUser.user_groups.title}</div>


          {(!this.props.userGroups || this.props.userGroups.length == 0) && this.props.loading && 
            this._renderLoading()
          }

          {this.props.userGroups.length > 0 && 
            <div>
              <div className={styles.helpText}>{this.localizedUser.user_groups.sub_text}</div>
              <div className={styles.scrollContainer}>
                  <InfiniteScroll
                      pageStart={0}
                      initialLoad={false}
                      hasMore={this.props.currentPage < this.props.totalPages}
                      loadMore={() => { this._loadMoreUserGroups() }}
                      useWindow={false}
                  > 
                      {this._renderUserGroups()}
                  </InfiniteScroll>
              </div>
            </div>
          }
          
          {this.props.userGroups.length == 0 && !this.props.loading &&
            <PlaceholderEmptyMessage
              title={this.localizedUser.user_groups.empty_message.title}
              message={this.localizedUser.user_groups.empty_message.message}
              image={EmptyMessageIcon}
              className={styles.emptyMessage}
              visible={true}
            />
          }
        </div>
    );
  }

  _renderUserGroups(){
        var rows = Array();
        
        this.props.userGroups.forEach((userGroup, index) => {
          let iconLength = _.size(userGroup.icons);
            rows.push(
                <Col md={12} className={styles.column} key={index}>
                    <div
                        onClick={() => {
                            this._handleUserGroupClick(userGroup);
                        }}
                        className={cx(styles.userGroup)}
                    >
                        <div>
                            {iconLength === 1 && this._renderFirstUserIcon(userGroup)}
                            {iconLength >= 2 && this._renderSecondUserIcon(userGroup)}
                            {iconLength === 0 && this._renderDefaultIcon()}
                        </div>
                        <div className={styles.userGroupDetails}>
                            <div className={styles.name}>
                                <Text lines={2} text={userGroup.name} />
                            </div>
                            <div className={styles.email}>
                                {userGroup.usersCount} {userGroup.usersCount == 1 ? this.localizedCommons.user : this.localizedCommons.users}
                            </div>
                            <div className={styles.date}>
                                {this.localizedCommons.added_on} {dateformat(userGroup.createdDate, "dd mmm yyyy")}
                                <span className={styles.role}>
                                  {userGroup.admin &&
                                    this.localizedUser.user_groups.roles.admin
                                  } 
                                  {!userGroup.admin && userGroup.createStream && 
                                    this.localizedUser.user_groups.actions.create_stream
                                  }
                                </span>
                            </div>
                            
                        </div>
                    </div>
                </Col>
            )
        });

        return rows;
    }

    _renderLoading() {
        return (
          <div className={styles.loading}>
            <LoadingMessage
            className={styles.loadingInner}
            message={`${this.localizedCommonLoading.user_groups}...`}
            visible={true} />
          </div>
        )
    }
}

export default UserGroupListView;    